import { globalApi as api } from '../../api';

export const fetchEmployeeCount = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const client_id = sessionStorage.getItem('selectedClient');
    const response = await api.get(`/get_employee_count`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      params: (client_id && client_id !== 'null') ? { client_id } : {},
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const fetchLogActivities = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get_recent_activity_logs`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
// fetchEmployeeCount,fetchLogActivities,fetchUpcomingHolidays
export const fetchUpcomingHolidays = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const client_id = sessionStorage.getItem('selectedClient');
    const response = await api.get(`/get_upcoming_holidays`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      params: (client_id && client_id !== 'null') ? { client_id } : {},
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

